<template>
  <div class="referral1 center">
    <div class="column">
      <!-- <el-image
        :src="$domain + 'static/noten/website/home/index1_title1_img.png'"
        style="width: 780px;height: 129px;align-self: center;"
      ></el-image> -->
      <div>
        <div class="center-just box-title" style="caret-color: transparent;">
          为什么孩子要学习编程
        </div>
        <div class="center-just title-info" style="caret-color: transparent;">
          学习编程可以让孩子掌握一种有用的技能，并且有助于孩子在未来的职业发展中获得优势
        </div>
      </div>
      <div class="between">
        <div class="left">
          <div class="title">学习编程有以下优势：</div>
          <ul class="ul">
            <TransitionText></TransitionText>
          </ul>
        </div>
        <div class="right">
          <div
            class="login100-pic"
            @mousemove="mouseMove"
            @mouseleave="mouseLeave"
          >
            <el-image
              src="http://static.smallschoolbag.com/static/noten/website/home/index1_box1_img.png"
              class="image"
            ></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionText from "@/components/TransitionText.vue";
export default {
  components: { TransitionText },
  data() {
    return {};
  },
  methods: {
    mouseMove(e) {
      let x = e.offsetX; //相对元素的X偏移量
      let y = e.offsetY; //相对元素的Y偏移量
      let img = document.querySelector(".login100-pic");
      let x1 = img.offsetWidth; //元素的宽度
      let y1 = img.offsetHeight; //元素的高度
      document.querySelector(".login100-pic").style.cssText +=
        "will-change: transform";
      document.querySelector(
        ".login100-pic"
      ).style.cssText += `transform:perspective(630px) rotateX(${(x1 / 2 - x) /
        20}deg) rotateY(${(y1 / 2 - y) / 20}deg) scale3d(1.1,1.1,1.1)`;
    },
    mouseLeave(e) {
      setTimeout(function() {
        document.querySelector(".login100-pic").style.transform =
          "perspective(630px) rotateX(0deg) rotateY(0deg)";
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.referral1 {
  height: 900px;
  background: #fafbff;
  .column {
    width: 62.5%;
    // background: #1633a8;
    margin-top: 100px;
  }
  .title {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  .ul {
    padding: 20px;
    color: #6b7182;
    li {
      height: 70px;
    }
  }

  .left {
    margin-top: 94px;
  }

  .right {
    // background-color: brown;
    height: 500px;
    width: 800px;
    margin-top: 94px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    .login100-pic {
      width: 634px;
      cursor: pointer;
    }

    .image {
      max-width: 100%;
    }
  }
}

.box-title {
  height: 46px;
  font-size: 46px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
}

.title-info {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin-top: 33px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/programming/box/box1.vue